export default __webpack_public_path__ + "locales/pt-BR/ConvertPasswordDialog.json?hash=6484729c036a14d61d3f5e6063eca907";